// extracted by mini-css-extract-plugin
export default {"root":"CXnBzBQTlAgECwWh1aqj","player":"Wzzd6q3FlHwMQJoNiSW6","duration":"UyN7uFpP9O9GU_zrHbwc","download":"bcc15ZQ8QsIwJ2HYI4HV"};